let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4bZL4")).then(() => parcelRequire('bAJpj'));